import React from 'react';
import { toast } from 'sonner';
import { Download, Copy, Mail, QrCode } from 'lucide-react';
import { Button } from '../ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const qrImg = (data) => `${BACKEND_URL}/api/public/qr?data=${encodeURIComponent(data || '')}`;

const downloadQr = async (url, filename) => {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objUrl);
  } catch (e) {
    toast.error('Could not download the QR code');
  }
};

const copyLink = async (link) => {
  try {
    await navigator.clipboard.writeText(link);
    toast.success('Link copied');
  } catch (e) {
    toast.error('Could not copy link');
  }
};

const QrTile = ({ icon: Icon, title, sub, link, filename, testid }) => (
  <div className="rounded-xl border border-border bg-background p-4 flex flex-col items-center text-center" data-testid={testid}>
    <div className="flex items-center gap-1.5 text-sm font-medium text-foreground">
      <Icon className="h-4 w-4 text-primary" /> {title}
    </div>
    <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>
    {link ? (
      <img src={qrImg(link)} alt={`${title} QR code`} className="h-40 w-40 my-3 rounded-lg border border-border bg-white" data-testid={`${testid}-img`} />
    ) : (
      <div className="h-40 w-40 my-3 rounded-lg border border-dashed border-border flex items-center justify-center text-xs text-muted-foreground">Not available</div>
    )}
    <div className="flex gap-2 w-full">
      <Button variant="outline" size="sm" className="flex-1 gap-1.5" onClick={() => copyLink(link)} disabled={!link} data-testid={`${testid}-copy`}>
        <Copy className="h-3.5 w-3.5" /> Copy link
      </Button>
      <Button variant="outline" size="sm" className="flex-1 gap-1.5" onClick={() => downloadQr(qrImg(link), filename)} disabled={!link} data-testid={`${testid}-download`}>
        <Download className="h-3.5 w-3.5" /> Save
      </Button>
    </div>
  </div>
);

/** Two shareable QR codes for an event: the invite link and the email-list signup. */
export const QrShareCard = ({ event }) => {
  if (!event) return null;
  const inviteLink = event.event_invite_url || event.event_url;
  const signupLink = event.signup_url;
  const slug = event.slug || 'event';
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="qr-share">
      <QrTile
        icon={QrCode} title="Invite QR" sub="Opens the event page to RSVP"
        link={inviteLink} filename={`${slug}-invite-qr.png`} testid="qr-invite"
      />
      <QrTile
        icon={Mail} title="Email list QR" sub="Join this event's email list"
        link={signupLink} filename={`${slug}-emaillist-qr.png`} testid="qr-emaillist"
      />
    </div>
  );
};
